import * as React from 'react'
import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { getShortlistById } from '@disco/state-management/selectors/shortlists'

import { getShortlistBaseRoute } from 'utils/routing'

import DocumentHeadTags from 'components/document-head-tags'
import PlaylistShareDialog from 'components/modals/playlist/share'

import { useSelector } from 'hooks/use-redux'

const ShortlistShare = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { shortlistId } = useParams<{ shortlistId: string }>()

  const shortlist = useSelector(state =>
    getShortlistById(state, {
      id: shortlistId,
    }),
  )

  useEffect(() => {
    if (!shortlist || !shortlist.playlist) {
      navigate('/')
    }
  }, [shortlist, navigate])

  const closeModal = () => {
    const baseRoute = getShortlistBaseRoute(location)
    const returnPath = location?.state?.returnPath || '/'

    navigate(`${baseRoute}/shortlists/${shortlistId}/saved`, {
      state: { returnPath },
    })
  }
  const onShare = shareId => {
    const baseRoute = getShortlistBaseRoute(location)
    const path = `${baseRoute}/shortlists/${shortlistId}/shared/${shareId}`
    navigate(path)
  }

  if (!shortlist || !shortlist.playlist) return null

  return (
    <div>
      <DocumentHeadTags title="Share playlist | DISCO" />
      <PlaylistShareDialog
        playlist={shortlist.playlist}
        onShare={onShare}
        onClose={closeModal}
      />
    </div>
  )
}

export default ShortlistShare
